require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./article-20-importing-a-csv.json") })
        }
      }, "path---article-20-importing-a-csv");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---article-20-importing-a-csv!./.cache/json/article-20-importing-a-csv.json
// module id = 536
// module chunks = 231608221292675